export default __webpack_public_path__ + "static/media/boxpost.37fcf27f.ico";